
import Env from '../base/env'
import Channels from '../base/channels'
import gsap from 'gsap'

class Launcher
{
    constructor()
    {
        if(Env.$launcher == null) return false
        // Dom
        this.view = Env.$launcher
        // Vars
        this.viewport = Env.framework.toolbox.getViewport()
        // Flags
        this.NO_INTRO = false
        this.LAUNCHED = false
        this.SPEED = 5
        // if(Env.mobileCSS == true) {
        //     this.NO_INTRO = true
        // }
        // FNs
        this.setup()
    }


    completeIn()
    {
        setTimeout(() => {
            this.out()
        }, 600);
    }

    completeOut()
    {
        Env.$html.classList.add('ui--isReady')
        this.LAUNCHED = true
        Env.$master.removeChild(this.view)
    }

    destroy()
    {

    }

    noLaunch()
    {
        Env.$master.removeChild(this.view)
        const timeoutTime = (Env.mobileCSS == true)?200:1000;
        setTimeout(() => {
            Env.$html.classList.add('ui--isReady')
            setTimeout(() => {
              Channels.emit('launcher::exit')
            }, 500);
            this.LAUNCHED = true
        }, timeoutTime);
        setTimeout(() => {
            Env.$html.classList.add('ui--isFinalize')
        }, 2000);
    }

    out()
    {
        const $gridItems = document.querySelectorAll('.grid-item')
        // const $itemsFx = [$gridItems[0].querySelector('.inner'),$gridItems[1].querySelector('.inner')]

        const tl = gsap.timeline()

        tl.add([
          gsap.to(Env.$launcher.querySelector('.jsLogo'), { autoAlpha:1, duration:1 ,ease:'cubic.out' })
        ])

        tl.add([
          gsap.fromTo(Env.$launcher,{ autoAlpha:1 }, { autoAlpha:0, duration:1 ,ease:'cubic.out', onStart:()=>{
              setTimeout(() => {
                Channels.emit('launcher::exit')
              }, 300);
            }
          })
        ])

        tl.add(()=>{
          Env.$html.classList.add('ui--isReady')
          // setTimeout(() => {

          // }, 500);
          Env.$master.removeChild(this.view)
          this.LAUNCHED = true
        })
    }

    setup()
    {
        Env.framework.toolbox.resetScroll()
        if(this.NO_INTRO) {
            this.noLaunch()
        } else {
            setTimeout(() => {
                this.out()
            }, Env.mainLoading);
        }
    }

}

export default Launcher;
